<template>
    <div class="app-footer-container">
        <p class="title">——&nbsp;&nbsp;友情链接&nbsp;&nbsp;——</p>
        <div class="link-box">
            <div class="link-item" @click="toWebSite(1)">
                <div class="logo">
                    <img src="https://cdn.mvcsky.com/footer/p2ipo-link-logo2x.png" class="p2ipo" alt="">
                </div>
                <p class="name">上市孵化器</p>
            </div>
            <div class="link-item" @click="toWebSite(2)">
                <div class="logo">
                    <img src="https://cdn.mvcsky.com/mobile/bigbays-logo2x.png" class="bigbays" alt="">
                </div>
                <p class="name">湾潮</p>
            </div>
            <div class="link-item" @click="toWebSite(3)">
                <div class="logo">
                    <img src="https://cdn.mvcsky.com/footer/shyc-link-logo2x.png" class="b2bscm" alt="">
                </div>
                <p class="name">山海云仓</p>
            </div>
        </div>
        <div class="copyright-box">
            <p>苍穹云系统(深圳)有限公司版权所有Copyright©CQY All Rights Reserved</p>
            <a class="txt2" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022104031号</a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'appFooter',
    data() {
        return {}
    },
    methods: {
        /**
         * @function toWebSite 网站跳转
         */
        toWebSite(flag) {
            let url = '';
            switch (flag) {
                case 1:
                    url = 'http://www.p2ipo.com';
                    break;
                case 2:
                    url = 'https://www.bigbays.cn';
                    break;
                case 3:
                    url = 'http://web.p2ipo.com';
                    // url = 'http://www.b2bscm.net';
                    break;
                default:
                    break;
            }
            window.location.href = url;
        }
    }
}
</script>
<style lang="scss" scoped>
@import './AppFooter.scss';
</style>


// WEBPACK FOOTER //
// src/components/mobile/common/footer/AppFooter.vue